import storage from 'local-storage-fallback';

const KEY = 'cl-session-token';

export class SessionStorageService {
    static saveToken = (token) => storage.setItem(KEY, token);
    static getToken = () => storage.getItem(KEY);
    static resetToken = () => storage.removeItem(KEY);
}
